// // ** Icon imports
// import HomeIcon from 'mdi-material-ui/Home'
// import CogIcon from 'mdi-material-ui/Cog'
// import { BiSolidCoupon } from "react-icons/bi";

const navigation = () => {
  return []
}

export default navigation
